import { heroTextData } from './components/Hero/lang.js';
import { generateTestimonialsLang, testimonialsEN, testimonialsES } from './utils.js';

const testimonialsDataES = {
  ...heroTextData.es,
  ...generateTestimonialsLang(testimonialsES)
};
const testimonialsDataEN = {
  ...heroTextData.en,
  ...generateTestimonialsLang(testimonialsEN)
};
console.log(testimonialsDataES);
export { testimonialsDataEN, testimonialsDataES };
